import React from 'react';
import { Star, MessageSquareQuote, ArrowRight } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function TestimonialsSection() {
  return <section className="w-full bg-gray-900 py-16 px-4" data-id="element-328">
      <div className="max-w-5xl mx-auto" data-id="element-329">
        <div className="flex items-center justify-center mb-10" data-id="element-330">
          <MessageSquareQuote size={32} className="text-amber-500 mr-3" data-id="element-331" />
          <h2 className="text-3xl font-bold text-white" data-id="element-332">
            Projected Shift + Real Validation
          </h2>
        </div>
        <p className="text-xl text-center text-gray-300 mb-12 max-w-3xl mx-auto" data-id="element-333">
          This book has transformed thousands. From students with no experience,
          to parents, entrepreneurs, and first-time leaders.
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-334">
          {/* Testimonio 1 */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-335">
            <div className="flex text-amber-400 mb-4" data-id="element-336">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-337" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-338">
              "I went from invisible to leading over 50 people with a shared
              mission. It all started with this book."
            </p>
            <div className="flex items-center" data-id="element-339">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-340">
                <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Emily J." className="w-full h-full object-cover" data-id="element-341" />
              </div>
              <div data-id="element-342">
                <p className="font-semibold text-gray-200" data-id="element-343">Emily Johnson</p>
                <p className="text-sm text-gray-400" data-id="element-344">21, Texas</p>
              </div>
            </div>
          </div>
          {/* Testimonio 2 */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-345">
            <div className="flex text-amber-400 mb-4" data-id="element-346">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-347" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-348">
              "I used to think leadership was for the rich or famous. Now I lead
              at work—with principles, not pretense."
            </p>
            <div className="flex items-center" data-id="element-349">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-350">
                <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="David M." className="w-full h-full object-cover" data-id="element-351" />
              </div>
              <div data-id="element-352">
                <p className="font-semibold text-gray-200" data-id="element-353">David Miller</p>
                <p className="text-sm text-gray-400" data-id="element-354">40, Ohio</p>
              </div>
            </div>
          </div>
          {/* Testimonio 3 */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-355">
            <div className="flex text-amber-400 mb-4" data-id="element-356">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-357" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-358">
              "I'd never done anything public before. Now I coordinate a youth
              group. This book gave me the tools."
            </p>
            <div className="flex items-center" data-id="element-359">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-360">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Sophia M." className="w-full h-full object-cover" data-id="element-361" />
              </div>
              <div data-id="element-362">
                <p className="font-semibold text-gray-200" data-id="element-363">Sophia Martinez</p>
                <p className="text-sm text-gray-400" data-id="element-364">25, California</p>
              </div>
            </div>
          </div>
          {/* Testimonio 4 - Nuevo */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-365">
            <div className="flex text-amber-400 mb-4" data-id="element-366">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-367" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-368">
              "I used to stay quiet in every meeting… even when I had better
              ideas. Now I lead weekly strategy sessions at my company—and
              people follow my lead."
            </p>
            <div className="flex items-center" data-id="element-369">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-370">
                <img src="https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Angela R." className="w-full h-full object-cover" data-id="element-371" />
              </div>
              <div data-id="element-372">
                <p className="font-semibold text-gray-200" data-id="element-373">Angela Ruiz</p>
                <p className="text-sm text-gray-400" data-id="element-374">34, Arizona</p>
              </div>
            </div>
          </div>
          {/* Testimonio 5 - Nuevo */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-375">
            <div className="flex text-amber-400 mb-4" data-id="element-376">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-377" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-378">
              "I always thought activism was for extroverts. But this book
              showed me how to build influence from the inside out. Now I run a
              podcast and lead local initiatives."
            </p>
            <div className="flex items-center" data-id="element-379">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-380">
                <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Noah E." className="w-full h-full object-cover" data-id="element-381" />
              </div>
              <div data-id="element-382">
                <p className="font-semibold text-gray-200" data-id="element-383">Noah Evans</p>
                <p className="text-sm text-gray-400" data-id="element-384">26, Georgia</p>
              </div>
            </div>
          </div>
          {/* Testimonio 6 - Nuevo */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-385">
            <div className="flex text-amber-400 mb-4" data-id="element-386">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-387" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-388">
              "I never saw myself as a leader—just a mom trying to keep things
              together. But once I applied these principles… my kids started
              seeing me as a guide, not just a parent."
            </p>
            <div className="flex items-center" data-id="element-389">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-390">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Rachel S." className="w-full h-full object-cover" data-id="element-391" />
              </div>
              <div data-id="element-392">
                <p className="font-semibold text-gray-200" data-id="element-393">Rachel Simmons</p>
                <p className="text-sm text-gray-400" data-id="element-394">42, Utah</p>
              </div>
            </div>
          </div>
          {/* Testimonio 7 - Nuevo */}
          <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700" data-id="element-395">
            <div className="flex text-amber-400 mb-4" data-id="element-396">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-397" />)}
            </div>
            <p className="text-gray-300 mb-6 italic" data-id="element-398">
              "I was stuck posting content no one read. Now I've grown a
              following, launched a movement, and finally feel heard."
            </p>
            <div className="flex items-center" data-id="element-399">
              <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-400">
                <img src="https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="Tyler B." className="w-full h-full object-cover" data-id="element-401" />
              </div>
              <div data-id="element-402">
                <p className="font-semibold text-gray-200" data-id="element-403">Tyler Brooks</p>
                <p className="text-sm text-gray-400" data-id="element-404">29, Colorado</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-gray-900 p-6 rounded-lg border border-gray-700" data-id="element-405">
          <div className="flex items-start" data-id="element-406">
            <div className="bg-gray-800 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-407">
              <Star size={24} className="text-amber-500" data-id="element-408" />
            </div>
            <p className="text-lg text-gray-300" data-id="element-409">
              <span className="font-semibold text-amber-400" data-id="element-410">
                Over 25,000 readers
              </span>{' '}
              across the U.S. are already using this method to influence,
              mobilize, and lead.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center bg-gray-800 p-8 rounded-lg shadow-md border border-gray-700" data-id="element-411">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-412">
            Join These Success Stories Today
          </h3>
          <p className="text-lg text-gray-300 mb-6" data-id="element-413">
            Don't wait another day to start your leadership transformation. Get
            immediate access to The Charlie Kirk Method.
          </p>
          <a href="https://ebooksociety.co/cart/51475293536537:1" className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-8 rounded-lg inline-flex items-center transition shadow-lg animate-subtle-pulse" data-id="element-414">
            Download Your Copy Now
            <ArrowRight size={20} className="ml-2" data-id="element-415" />
          </a>
          <div className="max-w-md mx-auto" data-id="element-416">
            <PaymentIcons data-id="element-417" />
          </div>
          <p className="text-sm text-gray-400 mt-4" data-id="element-418">
            Limited time offer: $19 USD (Regular price: $39 USD)
          </p>
        </div>
        <div className="mt-16" data-id="element-419">
          <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-420">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4S5MqG5bKeKCGdqJ7Q3XwL/ChatGPT_Image_30_sept_2025%2C_16_25_26.webp" alt="The Charlie Kirk Method book cover" className="w-full h-auto" data-id="element-421" />
          </div>
          <p className="text-center text-gray-300 mt-4 font-medium" data-id="element-422">
            Join thousands of leaders who are transforming their influence with
            The Charlie Kirk Method
          </p>
        </div>
      </div>
      <style jsx data-id="element-423">{`
        @keyframes subtlePulse {
          0%,
          100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.03);
          }
        }
        .animate-subtle-pulse {
          animation: subtlePulse 3s infinite ease-in-out;
        }
      `}</style>
    </section>;
}